import React, { useContext } from 'react';
import { Navbar } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useNavigate } from 'react-router-dom';
import { openLogoutPrompt } from './logoutPrompt';
import kravezLogo from '../Images/KravezLogoHeader.png';
import { MyContext } from './Context';
import '../Customize_Css/Navbar.css';

const CustomNavbar = () => {
  const { isSidebarOpen, setIsSidebarOpen } = useContext(MyContext);
  const navigate = useNavigate();

  const epicxTenantIdRaw = localStorage.getItem('epicxTenantId');
  const userRole = localStorage.getItem('role');
  let epicxTenantId = '';
  if (epicxTenantIdRaw) {
    epicxTenantId = epicxTenantIdRaw.slice(5).replace(/\d{4}-\d{2}-\d{2}$/, '');
  }

  const homePath = userRole === 'employee' ? '/view-orders' : '/dashboard';
  const roleLabel = userRole === 'employee' ? 'Employee' : userRole === 'tenant' ? 'Admin' : '';
  const initial = epicxTenantId ? epicxTenantId.charAt(0).toUpperCase() : 'A';

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <Navbar expand="lg" className="app-header">
        <button type="button" className="app-header-brand" onClick={() => navigate(homePath)} title="Go to home">
          <img src={kravezLogo} alt="Kravez" className="app-header-logo" />
          {/* <span className="app-header-divider" aria-hidden="true" /> */}
          {/* <span className="app-header-name">Fresh Delish</span> */}
        </button>
        <button
          type="button"
          onClick={toggleSidebar}
          className="app-header-menu"
          aria-label="Toggle sidebar"
        >
          <i className="bi bi-list"></i>
        </button>

        <Navbar.Toggle aria-controls="basic-navbar-nav" aria-label="Account menu" />
        <Navbar.Collapse id="basic-navbar-nav">
          <div className="app-header-actions">
            <div className="app-header-account">
              <div className="app-header-user" title={`Logged in as ${epicxTenantId}`}>
                <span className="app-header-avatar">{initial}</span>
                <span className="app-header-user-meta">
                  <span className="app-header-user-name">{epicxTenantId}</span>
                  {roleLabel && <span className="app-header-user-role">{roleLabel}</span>}
                </span>
              </div>

              <button
                type="button"
                className="app-header-action"
                title="Settings"
                aria-label="Settings"
                onClick={() => navigate('/settings')}
              >
                <i className="bi bi-gear"></i>
                <span>Settings</span>
              </button>

              <button
                type="button"
                className="app-header-action app-header-logout"
                title="Logout"
                aria-label="Logout"
                onClick={() => openLogoutPrompt(navigate)}
              >
                <i className="bi bi-box-arrow-right"></i>
                <span>Logout</span>
              </button>
            </div>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default CustomNavbar;
